import {
  createColumnHelper,
  getCoreRowModel,
  getFacetedMinMaxValues,
  getFacetedRowModel,
  getFacetedUniqueValues,
  getFilteredRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  useReactTable,
} from '@tanstack/react-table';
import PaginatedTable from '../Common/PaginatedTable';
import { HiDownload, HiEye, HiPencilAlt, HiXCircle } from 'react-icons/hi';
import { SubCategoryManual } from '../../Models/SubCategoryManual';

export default function ManualListTable({
  data,
  deleteManual,
  setselectedManual,
}: {
  data: SubCategoryManual[];
  deleteManual(id: number): void;
  setselectedManual(manual: SubCategoryManual): void;
}) {
  const columnHelper = createColumnHelper<SubCategoryManual>();

  const columns = [
    columnHelper.accessor((row) => row.id, {
      id: 'id',
      header: '',
      cell: (info) => (
        <div className='flex justify-center gap-2 items-baseline'>
          <a
            href={info.row.original.manualUrl!}
            download={info.row.original.manualName}
          >
            <button
              className='px-2'
              disabled={info.row.original.manualUrl === null ? true : false}
              style={{ color: 'blue' }}
            >
              <HiDownload size={20} />
            </button>
          </a>
          <button
            type='button'
            className='buttonMain p-2'
            onClick={() => setselectedManual(info.row.original)}
          >
            <HiPencilAlt />
          </button>
          <button
            type='button'
            className='buttonCancel p-2'
            onClick={() => deleteManual(info.getValue())}
          >
            <HiXCircle />
          </button>
        </div>
      ),
      footer: (info) => info.column.id,
      size: 35,
      enableColumnFilter: false,
    }),
    columnHelper.accessor((row) => row.manufacturer?.name, {
      id: 'manufacturerId',
      header: 'Manufacturer',
      sortingFn: 'alphanumeric',
      footer: (info) => info.column.id,
      enableColumnFilter: false,
    }),
    columnHelper.accessor((row) => row.subCategory?.name, {
      id: 'subcategoryId',
      header: 'Sub Category',
      sortingFn: 'alphanumeric',
      filterFn: 'includesString',
      enableColumnFilter: false,
    }),
    columnHelper.accessor((row) => row.manualName, {
      id: 'manualName',
      header: 'Manual Name',
      sortingFn: 'alphanumeric',
      footer: (info) => info.column.id,
      enableColumnFilter: false,
    }),
  ];

  const table = useReactTable({
    data,
    columns,
    initialState: {
      pagination: {
        pageIndex: 0,
        pageSize: 20,
      },
    },
    getSortedRowModel: getSortedRowModel(),
    getCoreRowModel: getCoreRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getFacetedRowModel: getFacetedRowModel(),
    getFacetedUniqueValues: getFacetedUniqueValues(),
    getFacetedMinMaxValues: getFacetedMinMaxValues(),
  });

  return (
    <>
      <div className='w-full mx-auto overflow-x-auto'>
        <PaginatedTable
          table={table}
          dataCount={data.length}
          columnResizeMode='onChange'
          showFilters={true}
        />
      </div>
    </>
  );
}
